'use strict';

exports.__esModule = true;
exports.TypeUtils = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TPA_WIDGET_TYPE = 'wysiwyg.viewer.components.tpapps.TPAWidget';
var TPA_WIDGET_NATIVE_TYPE = 'wysiwyg.viewer.components.tpapps.TPAWidgetNative';

var TypeUtils = exports.TypeUtils = function () {
  function TypeUtils(typesData) {
    _classCallCheck(this, TypeUtils);

    this._typesData = typesData;
  }

  TypeUtils.prototype.getSdkType = function getSdkType(viewerType, tpaWidgetId) {
    var typesData = this._typesData;
    var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
    var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;
    var defaultSdkType = typesData.defaultSdkType;
    return sdkTypeByWidgetId[tpaWidgetId] || sdkTypeByViewerType[viewerType] || defaultSdkType;
  };

  TypeUtils.prototype.getFullSdkType = function getFullSdkType(viewerType, tpaWidgetId) {
    return '$w.' + this.getSdkType(viewerType, tpaWidgetId);
  };

  TypeUtils.prototype.getPotentialViewerTypes = function getPotentialViewerTypes(sdkType) {
    var typesData = this._typesData;
    var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
    var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

    var types = _lodash2.default.keys(sdkTypeByViewerType);
    var resultViewerTypes = types.filter(function (viewerType) {
      return sdkTypeByViewerType[viewerType] === sdkType;
    });
    var isPotentiallyTPA = _lodash2.default.includes(_lodash2.default.values(sdkTypeByWidgetId), sdkType);
    if (isPotentiallyTPA) {
      resultViewerTypes.push(TPA_WIDGET_TYPE, TPA_WIDGET_NATIVE_TYPE);
    }
    return resultViewerTypes;
  };

  TypeUtils.prototype.setType = function setType(viewerType, sdkType) {
    var sdkTypeByViewerType = this._typesData.sdkTypeByViewerType;
    sdkTypeByViewerType[viewerType] = sdkType;
  };

  _createClass(TypeUtils, [{
    key: 'Types',
    get: function get() {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

      var allSdkTypes = _lodash2.default.uniq(_lodash2.default.values(sdkTypeByViewerType).concat(_lodash2.default.values(sdkTypeByWidgetId)));
      return _lodash2.default.zipObject(allSdkTypes, allSdkTypes);
    }
  }, {
    key: 'defaultSdkType',
    get: function get() {
      var typesData = this._typesData;
      return typesData.defaultSdkType;
    }
  }]);

  return TypeUtils;
}();
//# sourceMappingURL=typeUtils.js.map